import _ from 'lodash';
import React, { Component } from 'react';
import { EDITOR_DESKTOP_LEFT_BAR_MENU_ID } from 'crazyEditor/core/constants/editorConstants';
import { connect } from 'react-redux';
import { setSelectedElementIds } from 'crazyEditor/redux/modules/stage/stage';
import PopoverWithArrow from '../../../../shared/components/PopoverWithArrow/PopoverWithArrow';
import DraggableMenuElement from '../MenuElement/DraggableMenuElement';
import MenuElement from '../MenuElement/MenuElement';
import styles from '../TwoLevelesMenuStyle';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { isPageElementSelected, isBackgroundElementSelected } from 'crazyEditor/redux/modules/element/elementSelectors';
import { addDesktopElement } from 'crazyEditor/core/elements/utils/elementAddUpdateUtils';
import {getNormalizedTemplateTagSpecifics} from 'crazyEditor/redux/modules/templateTagSet/templateTagSelectors';
import * as Colors from 'material-ui/styles/colors';
import { getElementTooltip, getElementIcon, getElementName } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { emphasize } from 'material-ui/utils/colorManipulator';
import Scrollbars from 'shared/vendor/react-custom-scrollbars/src/Scrollbars/index';
import ChildrenFader from 'shared/components/ChildrenFader';
import Subheader from 'material-ui/Subheader';
import CustomSvgIcon from 'crazyEditor/components/EditorUI/BaseUI/CustomSvgIcon/CustomSvgIcon';
import { EDITOR_STAGE_ID } from 'crazyEditor/core/constants/editorConstants';
import { HEADER_HEIGHT } from 'crazyEditor/core/constants/editorConstants';

const classes = require('../DesktopEditorLeftBar.scss');

@connect(
  state => ({
    isResizingElement: state.stage.isResizingElement,
    isBackgroundElementSelected: isBackgroundElementSelected(state),
    isPageElementSelected: isPageElementSelected(state),
    isDraggingElement: state.stage.isDraggingElement,
    selectedElementIds: state.stage.selectedElementIds,
    stageLayoutTop: state.stage.layout.top,
    stageLayoutHeight: state.stage.layout.height,
    left: state.stage.layout.left,
    templateTagSetName: state.templateTagSet.name,
    templateTagSetLink: state.templateTagSet.link,
    templateTagSpecifics: getNormalizedTemplateTagSpecifics(state),
  }),
  {setSelectedElementIds}
)
@Radium
export default class SecondLevelMenu extends Component {
  state = {
    hoveredElementIndex: null,
    elements: null,
    childrenFaderKey: 0,
  };

  componentWillMount() {
    const {elements, open} = this.props;
    if (open) {
      this.setState({elements: elements});
    }
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.leftMenuSelectedItemIndex > this.props.leftMenuSelectedItemIndex) && this.props.leftMenuSelectedItemIndex !== null) {
      this.setState({
        enterStyle: {transform: 'translateY(30px)', opacity: 0},
        leaveStyle: {transform: 'translateY(-30px)', opacity: 0}
      });
    } else if ((nextProps.leftMenuSelectedItemIndex < this.props.leftMenuSelectedItemIndex) && nextProps.leftMenuSelectedItemIndex !== null) {
      this.setState({
        enterStyle: {transform: 'translateY(-30px)', opacity: 0},
        leaveStyle: {transform: 'translateY(30px)', opacity: 0}
      });
    }
    if (!this.props.open && nextProps.open) {
      const {childrenFaderKey} = this.state; // we need to keep the old elements for closing animation
      this.setState({childrenFaderKey: childrenFaderKey + 1});
    }
    if (nextProps.open) {
      this.setState({elements: nextProps.elements});
    }
  }


  renderMenuContent() {
    const { onRequestClose, stageLayoutHeight, left} = this.props;
    const {elements} = this.state;
    return ([<div key="placeHolderDiv" style={{height: 20}}/>, ..._.map(elements, ({subheader, selectOnly, ...element}, index) => {
      if (subheader) {
        return (
          <Subheader
            key = {index}
            style={styles.subheader}
          >
            {subheader}
          </Subheader>
        );
      }
      const onMouseEnter = () => this.setState({hoveredElementIndex: index});
      const onMouseLeave = window.leaveTooltipOpen ? undefined : () => this.setState({hoveredElementIndex: null});
      if (selectOnly) {
        return (<MenuElement
          key = {index}
          ref = {`menuElement${index}`}
          labelStyle={{color: Colors.grey700, paddingLeft: 10}}
          responsive = {false}
          stageLayoutHeight={stageLayoutHeight}
          style={{paddingLeft: 10}}
          left={left}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          {...element}
        />);
      }
      return (
        <DraggableMenuElement
          key = {index}
          ref = {`menuElement${index}`}
          labelStyle={{color: Colors.grey700, paddingLeft: 10, paddingRight: 10, overflow: 'hidden', textOverflow: 'ellipsis'}}
          responsive = {false}
          stageLayoutHeight={stageLayoutHeight}
          left={left}
          onClick={() => {
            window.setTimeout(() => {
              addDesktopElement(element.elementType, null, element.elementPreset);
            }, 190);
            onRequestClose();
          }}
          onDrop={position => {
            addDesktopElement(element.elementType, position, element.elementPreset);
            onRequestClose();
          }}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          {...element}
        />);
    })]);
  }

  render() {
    const { open, isResizingElement, isDraggingElement } = this.props;
    const {elements, childrenFaderKey, hoveredElementIndex, enterStyle, leaveStyle} = this.state;
    let tooltip;
    let icon;
    let name;
    if (hoveredElementIndex !== null && elements && elements[hoveredElementIndex]) {
      const {elementPreset, elementType} = elements[hoveredElementIndex];
      if (elementPreset || elementType) {
        tooltip = getElementTooltip(elementPreset || elementType);
        icon = getElementIcon(elementPreset || elementType);
        name = getElementName(elementPreset || elementType);
      }
    }
    return (
      <div
        className={classes.enterFromLeft}
        style={[styles.secondLevelMenuContainer, {transition: open ? '250ms cubic-bezier(0.23, 1, 0.32, 1)' : '250ms cubic-bezier(0.45, 0.06, 0.9, 0.38)'}, (isResizingElement || isDraggingElement) && {pointerEvents: 'none'}, {opacity: open ? 1 : 0, transform: open ? null : 'translateX(-105%)'}]}
      >
        <Scrollbars>
          { elements &&
            <ChildrenFader key={childrenFaderKey} visible path={elements} transitionDurationMs={110} enterStyle={{...enterStyle, transitionTimingFunction: 'ease-out'}} leaveStyle={{...leaveStyle, transitionTimingFunction: 'ease-in'}}>
              {this.renderMenuContent()}
            </ChildrenFader>
          }
        </Scrollbars>
        <PopoverWithArrow
          animated={false}
          open={open && (hoveredElementIndex !== null)}
          style={{backgroundColor: Colors.blue500, padding: 20, fontSize: 14, color: Colors.white}}
          useLayerForClickAway={false}
          anchorEl = {this.refs[`menuElement${hoveredElementIndex}`]}
          anchorOrigin = {{horizontal: 'right', vertical: 'center'}}
          targetOrigin = {{horizontal: 'left', vertical: 'center'}}
          constrainTo = {{top: HEADER_HEIGHT}}
        >
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: 160, justifyContent: 'space-around'}}>
            <CustomSvgIcon path={icon} width={40} height={40} color={Colors.white}/>
            <div style={{fontWeight: 500, textTransform: 'uppercase', marginTop: 10, marginBottom: 10, width: 180, textAlign: 'center'}}>{name}</div>
            <div style={{maxWidth: 160}}>{tooltip || 'All the details about your product goes here'}</div>
          </div>
        </PopoverWithArrow>
      </div>
    );
  }
}

MenuElement.propTypes = {
  open: PropTypes.bool,
  elements: PropTypes.array,
  onRequestClose: PropTypes.func.isRequired,
};